module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-new-arrow-right-icon.729386c4.svg";